export function normalizeStripeEnvValue(
  value: string | undefined,
): string | undefined {
  if (typeof value !== "string") return undefined;
  const normalized = value.trim();
  return normalized.length > 0 ? normalized : undefined;
}

export function getStripeEnvValue(key: string): string | undefined {
  return normalizeStripeEnvValue(process.env[key]);
}

export function getStripePriceIdEnv(key: string): string | undefined {
  const value = getStripeEnvValue(key);
  if (!value) return undefined;
  return value;
}

export function getStripePriceIdEnvOrFallback(
  key: string,
  fallback: string,
): string {
  return getStripePriceIdEnv(key) ?? fallback;
}

export function resolveStripePriceId(
  value: string | undefined,
  fallback: string,
): string {
  return normalizeStripeEnvValue(value) ?? fallback;
}

export function collectStripePriceIds(keys: readonly string[]): string[] {
  const unique = new Set<string>();

  for (const key of keys) {
    const value = getStripePriceIdEnv(key);
    if (!value) continue;
    unique.add(value);
  }

  return Array.from(unique);
}
